export const UNINITIALIZED = 'UNINITIALIZED';
export const PENDING = 'PENDING';
export const SUCCEEDED = 'SUCCEEDED';
export const FAILED = 'FAILED';